import React from 'react';

function Review() {
    return (
        <>
            <section className="blog_detail_section">
                <div className="container">
                    <div className="blog_inner_pannel">
                        <div className="section_title">
                            <h2>Child Safety Standards and CSAE Policy</h2>
                        </div>
                        <div className="info">
                            <p>
                                MiSoulmate is dedicated to protecting children from exploitation and abuse on our platform.
                                We strictly prohibit any form of child sexual abuse material (CSAM) and operate in full compliance with global child protection laws and Google Play's Child Safety Standards.
                            </p>

                            <h3>1. Platform Eligibility</h3>
                            <p>
                                MiSoulmate is a matchmaking app intended exclusively for users aged 18 and older. We block underage users through age verification and account moderation.
                            </p>

                            <h3>2. Prohibited Content and Behavior</h3>
                            <ul>
                                <li>Child sexual abuse or exploitation material (CSAM)</li>
                                <li>Sexualization or grooming of minors</li>
                                <li>Uploading images of minors in inappropriate contexts</li>
                                <li>Impersonation of minors or adults attempting to contact minors</li>
                            </ul>

                            <h3>3. Reporting and Response</h3>
                            <p>
                                Users can report CSAM or suspicious activity via the app or by emailing <strong>support@misoulmate.com</strong>. Our safety team reviews all reports and notifies appropriate authorities as required.
                            </p>

                            <h3>4. Enforcement and Moderation</h3>
                            <p>
                                We use a combination of automated detection and human review to identify and remove prohibited content. Any accounts involved in CSAM are banned immediately and reported.
                            </p>

                            <h3>5. Staff Training</h3>
                            <p>
                                Our Trust & Safety team is trained to detect and escalate cases of CSAM in accordance with international standards.
                            </p>

                            <h3>6. Designated Contact</h3>
                            <p>
                                For child safety-related issues or compliance questions, please contact our designated officer at <strong>support@misoulmate.com</strong>. This email is monitored and maintained by our safety team.
                            </p>

                            <h3>7. Legal Compliance</h3>
                            <p>
                                MiSoulmate complies with all regional and national child protection laws and reports verified CSAM content to organizations like NCMEC and law enforcement as required.
                            </p>

                            <p><strong>Last Updated:</strong> July 1, 2025</p>
                        </div>

                        <div className="quote_block">
                            <h2>"We are committed to keeping our platform safe, respectful, and free from exploitation."</h2>
                            <p><span className="name">MiSoulmate Inc.,</span> Trust & Safety Team</p>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default Review;
